//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";

var debounce = require("lodash.debounce");

export function Avaliacao() {
  const token = localStorage.getItem("token") || "";

  const [answers,setAnswers] = useState({});


  


  return (
    <div className="row">
      <div className="col-12">

      <div className={"py-5 px-3"}>
      <div className={ "card-body"} id="card">
      <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              AVALIAÇÃO
            </h4>
            <br></br>
            <br></br>

            {/* <p>texto avaliação</p> */}

            <Link to={'/usabilidade/avaliacao/visibilidade'}><button className="btn btn-outline-primary btn-lg w-100">
            Visibilidade do status do software
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/correspondecia'}><button className="btn btn-outline-primary btn-lg w-100">
            Correspondência entre o software e o mundo real
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/controle'}><button className="btn btn-outline-primary btn-lg w-100">
            Controle e liberdade do usuário
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/consistencia'}><button className="btn btn-outline-primary btn-lg w-100">
            Consistências e padrões na comunicação
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/prevencao'}><button className="btn btn-outline-primary btn-lg w-100">
            Prevenção de erros
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/reconhecimento'}><button className="btn btn-outline-primary btn-lg w-100">
            Reconhecimento em vez de recordação
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/flexibilidade'}><button className="btn btn-outline-primary btn-lg w-100">
            Flexibilidade, eficiência e produtividade
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/design'}><button className="btn btn-outline-primary btn-lg w-100">
            Design e comunicação minimalista
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/ajuda'}><button className="btn btn-outline-primary btn-lg w-100">
            Ajuda aos usuários a prevenir, reconhecer, diagnosticar e recuperar de erros
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/documentacao'}><button className="btn btn-outline-primary btn-lg w-100">
            Ajuda e documentação
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/gestao'}><button className="btn btn-outline-primary btn-lg w-100">
            Gestão de logs e compartilhamento
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/uso'}><button className="btn btn-outline-primary btn-lg w-100">
            Padrão no uso de informações
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/visualizacao'}><button className="btn btn-outline-primary btn-lg w-100">
            Visualização e análise das informações geradas
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/adaptabilidade'}><button className="btn btn-outline-primary btn-lg w-100">
            Adaptabilidade em diversas telas
                        </button></Link>
                        <br/>
                        <br/>
            <Link to={'/usabilidade/avaliacao/apresentacao'}><button className="btn btn-outline-primary btn-lg w-100">
            Apresentação da informação
                        </button></Link>
                        <br/>
                        <br/>
            
                        




                









      </div>
      </div>
      </div>

    </div>
  );
}
